<!--
  Renders the Resource - Benchmark app route
-->
<template>
  <div class="row cis-resource-benchmark">
    <div data-e2e-id="cis-resource-blog" class="col-lg-12 col-md-12 col-sm-12 template-content">
      <!-- Main Content -->
      <div class="col-lg-9 col-md-9 col-sm-12 template-main-content benchmark">
        <!-- Intro Title -->
        <h1 class="benchamrk__title">{{ routeData.fields.resourceTitle.value }}</h1>

        <!-- Intro Headline -->
        <h2 class="benchamrk__subtitle">
          <sc-text
            v-if="getBenchmarkData && getBenchmarkData.intro"
            tag="span"
            class="benchamrk__subtitle"
            :field="getBenchmarkData.intro"
          />
          {{ routeData.fields.resourceTitle.value }}
        </h2>

        <!-- Placeholder - CIS Benchmark Addition Info -->
        <sc-placeholder name="jss-benchmark-additional-info" :rendering="rendering" />

        <!-- Intro Text -->
        <sc-text
          v-if="getBenchmarkData && getBenchmarkData.introSub"
          tag="p"
          :field="getBenchmarkData.introSub"
        />

        <!-- Intro CTA -->
        <a
          v-if="getBenchmarkData && getBenchmarkData.introCta"
          class="c-cta--primary--benchmark"
          :href="`${getBenchmarkData.introCta.value.url}`"
          :tech_key="`${getBenchmarkKey}`"
          :tech_version="`${getBenchmarkTechVersion}`"
          :version="`${getBenchmarkVersion}`"
          @click="setRecentlyViewedBenchmarksCookie"
        >
          {{ getBenchmarkData.introCta.value.text }}
        </a>

        <!-- Label Above Boxes -->
        <sc-text
          v-if="getBenchmarkData && getBenchmarkData.labelMain"
          tag="h3"
          class="box__title"
          :field="getBenchmarkData.labelMain"
        />

        <!-- CIS Benchmark -->
        <div class="box">
          <sc-text
            v-if="getBenchmarkData && getBenchmarkData.labelBenchmark"
            tag="span"
            class="label"
            :field="getBenchmarkData.labelBenchmark"
          />

          <div class="columns">
            <div class="column">
              <sc-text
                v-if="getBenchmarkData && getBenchmarkData.headerBenchmark"
                tag="h3"
                class="column__header"
                :field="getBenchmarkData.headerBenchmark"
              />
              <sc-text
                v-if="getBenchmarkData && getBenchmarkData.descriptionBenchmark"
                tag="p"
                :field="getBenchmarkData.descriptionBenchmark"
              />
              <sc-link
                v-if="getBenchmarkData && getBenchmarkData.ctaBenchmark"
                :field="getBenchmarkData.ctaBenchmark"
                class="c-cta--secondary no-margin"
              />
            </div>
            <div class="column">
              <sc-text
                v-if="getBenchmarkData && getBenchmarkData.listLabelBenchmark"
                tag="h5"
                class="column__subheader"
                :field="getBenchmarkData.listLabelBenchmark"
              />
              <div v-for="benchmark in getBenchmarks" :key="benchmark.info">
                <div
                  v-for="(version, index) in benchmark.benchmarkVersions"
                  :key="`version${index}`"
                >
                  <div v-if="index === 0" class="benchmark">
                    {{ benchmark.benchmarkTitle }} ({{ version.version }})
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CIS-CAT Pro -->
        <div class="box" v-if="getCatPro.length > 0">
          <sc-text
            v-if="getBenchmarkData && getBenchmarkData.labelCisCatPro"
            tag="span"
            class="label"
            :field="getBenchmarkData.labelCisCatPro"
          />

          <div class="columns">
            <div class="column">
              <sc-text
                v-if="getBenchmarkData && getBenchmarkData.headerCisCatPro"
                tag="h3"
                class="column__header"
                :field="getBenchmarkData.headerCisCatPro"
              />
              <sc-text
                v-if="getBenchmarkData && getBenchmarkData.descriptionCisCatPro"
                tag="p"
                :field="getBenchmarkData.descriptionCisCatPro"
              />
              <sc-link
                v-if="getBenchmarkData && getBenchmarkData.ctaCisCatPro"
                :field="getBenchmarkData.ctaCisCatPro"
                class="c-cta--secondary"
              />
              <sc-text
                v-if="getBenchmarkData && getBenchmarkData.secureSuiteDescCisCatPro"
                tag="p"
                :field="getBenchmarkData.secureSuiteDescCisCatPro"
              />
              <sc-link
                v-if="getBenchmarkData && getBenchmarkData.secureSuiteCtaCisCatPro"
                :field="getBenchmarkData.secureSuiteCtaCisCatPro"
                class="c-cta--tertiary no-margin"
              />
            </div>
            <div class="column">
              <sc-text
                v-if="getBenchmarkData && getBenchmarkData.listLabelCisCatPro"
                tag="h5"
                class="column__subheader"
                :field="getBenchmarkData.listLabelCisCatPro"
              />
              <div v-for="item in getCatPro" :key="item.info">
                <div v-for="(version, index) in item.benchmarkVersions" :key="`version${index}`">
                  <div v-if="index === 0" class="benchmark">
                    {{ item.benchmarkTitle }} ({{ version.version }})
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Build Kits -->
        <div class="box" v-if="getBuildKits.length > 0">
          <sc-text
            v-if="getBenchmarkData && getBenchmarkData.labelBuildKits"
            tag="span"
            class="label"
            :field="getBenchmarkData.labelBuildKits"
          />

          <div class="columns">
            <div class="column">
              <sc-text
                v-if="getBenchmarkData && getBenchmarkData.headerBuildKits"
                tag="h3"
                class="column__header"
                :field="getBenchmarkData.headerBuildKits"
              />
              <p>
                <sc-text
                  v-if="getBenchmarkData && getBenchmarkData.descriptionBuildKits"
                  tag="span"
                  :field="getBenchmarkData.descriptionBuildKits"
                />
                {{ routeData.fields.resourceTitle.value }}
                <sc-text
                  v-if="getBenchmarkData && getBenchmarkData.descriptionAfterBuildKits"
                  tag="span"
                  :field="getBenchmarkData.descriptionAfterBuildKits"
                />
              </p>
              <sc-link
                v-if="getBenchmarkData && getBenchmarkData.ctaBuildKits"
                :field="getBenchmarkData.ctaBuildKits"
                class="c-cta--secondary"
              />
              <sc-text
                v-if="getBenchmarkData && getBenchmarkData.secureSuiteDescBuildKits"
                tag="p"
                :field="getBenchmarkData.secureSuiteDescBuildKits"
              />
              <sc-link
                v-if="getBenchmarkData && getBenchmarkData.secureSuiteCtaBuildKits"
                :field="getBenchmarkData.secureSuiteCtaBuildKits"
                class="c-cta--tertiary no-margin"
              />
            </div>
            <div class="column">
              <sc-text
                v-if="getBenchmarkData && getBenchmarkData.listLabelBuildKits"
                tag="h5"
                class="column__subheader"
                :field="getBenchmarkData.listLabelBuildKits"
              />
              <div v-for="item in getBuildKits" :key="item.info">
                <div v-for="(version, index) in item.benchmarkVersions" :key="`version${index}`">
                  <div v-if="index === 0" class="benchmark">
                    {{ item.benchmarkTitle }} ({{ version.version }})
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Hardened Images -->
        <div class="box" v-if="getImages.length > 0">
          <sc-text
            v-if="getBenchmarkData && getBenchmarkData.labelHardenedImages"
            tag="span"
            class="label"
            :field="getBenchmarkData.labelHardenedImages"
          />

          <div class="columns">
            <div class="column">
              <sc-text
                v-if="getBenchmarkData && getBenchmarkData.headerHardenedImages"
                tag="h3"
                class="column__header"
                :field="getBenchmarkData.headerHardenedImages"
              />
              <p>
                <sc-text
                  v-if="getBenchmarkData && getBenchmarkData.descriptionHardenedImages"
                  tag="span"
                  :field="getBenchmarkData.descriptionHardenedImages"
                />
                {{ routeData.fields.resourceTitle.value }}
                <sc-text
                  v-if="getBenchmarkData && getBenchmarkData.descriptionAfterHardenedImages"
                  tag="span"
                  :field="getBenchmarkData.descriptionAfterHardenedImages"
                />
              </p>
              <sc-link
                v-if="getBenchmarkData && getBenchmarkData.ctaHardenedImages"
                :field="getBenchmarkData.ctaHardenedImages"
                class="c-cta--secondary no-margin"
              />
            </div>
            <div class="column">
              <sc-text
                v-if="getBenchmarkData && getBenchmarkData.listLabelHardenedImages"
                tag="h5"
                class="column__subheader"
                :field="getBenchmarkData.listLabelHardenedImages"
              />
              <div v-for="item in getImages" :key="item.info">
                <div v-for="(version, index) in item.benchmarkVersions" :key="`version${index}`">
                  <div v-if="index === 0" class="benchmark">
                    {{ item.benchmarkTitle }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Gray Box Content -->
        <div
          v-if="
            (contentGrayBoxInfo().icon &&
              contentGrayBoxInfo().icon.value &&
              contentGrayBoxInfo().icon.value.src) ||
            (contentGrayBoxInfo().content && contentGrayBoxInfo().content.value)
          "
        >
          <content-gray-box :pageInfo="contentGrayBoxInfo()" />
        </div>

        <!-- Resources Section-->
        <sc-text
          v-if="getBenchmarkData && getBenchmarkData.threeColumnHeadline"
          tag="h2"
          class="column__headline"
          :field="getBenchmarkData.threeColumnHeadline"
        />

        <div class="three-column">
          <div class="column" v-if="getBenchmarkData && getBenchmarkData.threeColumnLeftContent">
            <sc-text
              v-if="getBenchmarkData && getBenchmarkData.threeColumnLeftHeadline"
              tag="h3"
              :field="getBenchmarkData.threeColumnLeftHeadline"
            />
            <p v-if="getBenchmarkData && getBenchmarkData.threeColumnLeftContent">
              <sc-text
                v-if="getBenchmarkData && getBenchmarkData.threeColumnLeftContent"
                tag="span"
                :field="getBenchmarkData.threeColumnLeftContent"
              />
              <span v-if="getBenchmarkData && getBenchmarkData.threeColumnLeftContent">{{
                routeData.fields.resourceTitle.value
              }}</span>
            </p>
            <sc-link
              v-if="
                getBenchmarkData &&
                getBenchmarkData.threeColumnLeftCta &&
                getBenchmarkData.threeColumnLeftCta.value &&
                getBenchmarkData.threeColumnLeftCta.value.href &&
                getBenchmarkData.threeColumnLeftCta.value.href.length > 0
              "
              :field="getBenchmarkData.threeColumnLeftCta"
              class="c-cta--tertiary"
            />
          </div>
          <div class="column" v-if="getBenchmarkData && getBenchmarkData.threeColumnMiddleContent">
            <sc-text
              v-if="getBenchmarkData && getBenchmarkData.threeColumnMiddleHeadline"
              tag="h3"
              :field="getBenchmarkData.threeColumnMiddleHeadline"
            />
            <p v-if="getBenchmarkData && getBenchmarkData.threeColumnMiddleContent">
              <sc-text
                v-if="getBenchmarkData && getBenchmarkData.threeColumnMiddleContent"
                :field="getBenchmarkData.threeColumnMiddleContent"
              />
            </p>
            <sc-link
              v-if="
                getBenchmarkData &&
                getBenchmarkData.threeColumnMiddleCta &&
                getBenchmarkData.threeColumnMiddleCta.value &&
                getBenchmarkData.threeColumnMiddleCta.value.href &&
                getBenchmarkData.threeColumnMiddleCta.value.href.length > 0
              "
              :field="getBenchmarkData.threeColumnMiddleCta"
              class="c-cta--tertiary"
            />
          </div>
          <div class="column" v-if="getBenchmarkData && getBenchmarkData.threeColumnRightContent">
            <sc-text
              v-if="getBenchmarkData && getBenchmarkData.threeColumnRightHeadline"
              tag="h3"
              :field="getBenchmarkData.threeColumnRightHeadline"
            />
            <p v-if="getBenchmarkData && getBenchmarkData.threeColumnRightContent">
              <sc-text
                v-if="getBenchmarkData && getBenchmarkData.threeColumnRightContent"
                :field="getBenchmarkData.threeColumnRightContent"
              />
            </p>
            <sc-link
              v-if="
                getBenchmarkData &&
                getBenchmarkData.threeColumnRightCta &&
                getBenchmarkData.threeColumnRightCta.value &&
                getBenchmarkData.threeColumnRightCta.value.href &&
                getBenchmarkData.threeColumnRightCta.value.href.length > 0
              "
              :field="getBenchmarkData.threeColumnRightCta"
              class="c-cta--tertiary"
            />
          </div>
        </div>
      </div>

      <!-- Right Rail -->
      <div class="col-lg-3 col-md-3 col-sm-12 template-sidebar" :class="{ addShadow: isContent }">
        <sc-rich-text
          v-if="getBenchmarkData && getBenchmarkData.rightRailContent"
          :field="getBenchmarkData.rightRailContent"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Placeholder, Text, RichText, Link } from '@sitecore-jss/sitecore-jss-vue';
import ContentGrayBox from './../CIS-Content-Gray-Box.vue';

const cleanName = (name) => {
  return name.replace('CIS', '').replace('Benchmark', '');
};

const isEmpty = (item) => {
  if (item.length) {
    return true;
  } else return false;
};

const sortVersion = (a, b) => {
  const isNumber = (v) => (+v).toString() === v;
  const aPart = a.benchmarkTitle.match(/\d+|\D+/g);
  const bPart = b.benchmarkTitle.match(/\d+|\D+/g);
  let i = 0;
  let len = Math.min(aPart.length, bPart.length);
  while (i < len && aPart[i] === bPart[i]) {
    i++;
  }
  if (i === len) {
    return aPart.length - bPart.length;
  }
  if (isNumber(aPart[i]) && isNumber(bPart[i])) {
    return bPart[i] - aPart[i];
  }
  return aPart[i].localeCompare(bPart[i]);
};

export default {
  name: 'CIS-Resource-Benchmark',
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  components: {
    ScPlaceholder: Placeholder,
    ScText: Text,
    ScRichText: RichText,
    ScLink: Link,
    ContentGrayBox
  },
  data: function () {
    return {
      isContent: false
    };
  },
  computed: {
    routeData() {
      // this.$jss is defined on the Vue instance by the SitecoreJssPlugin and provides
      // reactive access to the root level route data provided in layout service data.
      return this.$jss.routeData();
    },
    benchmarkVersions() {
      return this.routeData?.fields?.benchmarkVersions;
    },
    getBenchmarkData() {
      return this.$jss.routeData()?.fields?.benchmarkData?.fields;
    },
    getBenchmarkKey() {
      return this.$jss.routeData()?.fields?.technologyKey?.value;
    },
    getBenchmarkTechVersion() {
      return this.$jss.routeData()?.fields?.latestTechnologyVersion?.value;
    },
    getBenchmarkVersion() {
      return this.$jss.routeData()?.fields?.benchmarkVersions?.[0]?.fields?.benchmarkVersion?.value;
    },
    getBenchmarks() {
      const benchmark = [
        ...new Map(
          this.benchmarkVersions.map((l) => [
            cleanName(l.fields.benchmarkTitle.value),
            {
              benchmarkTitle: cleanName(l.fields.benchmarkTitle.value),
              benchmarkVersions: this.benchmarkVersions
                .filter(
                  (c) =>
                    cleanName(c.fields.benchmarkTitle.value) ===
                    cleanName(l.fields.benchmarkTitle.value)
                )
                .map((i) => ({
                  version: cleanName(i.fields.benchmarkVersion.value)
                }))
            }
          ])
        ).values()
      ].sort(sortVersion);

      return benchmark;
    },
    getCatPro() {
      const catPro = [
        ...new Map(
          this.benchmarkVersions
            .filter((c) => c.fields.proV4.value)
            .map((l) => [
              cleanName(l.fields.benchmarkTitle.value),
              {
                benchmarkTitle: cleanName(l.fields.benchmarkTitle.value),
                benchmarkVersions: this.benchmarkVersions
                  .filter(
                    (c) =>
                      cleanName(c.fields.benchmarkTitle.value) ===
                        cleanName(l.fields.benchmarkTitle.value) && c.fields.proV4.value
                  )
                  .map((i) => ({
                    version: cleanName(i.fields.benchmarkVersion.value)
                  }))
              }
            ])
        ).values()
      ].sort(sortVersion);

      return catPro;
    },
    getImages() {
      const images = [
        ...new Map(
          this.benchmarkVersions
            .filter((c) => isEmpty(c.fields.images))
            .map((l) => [
              cleanName(l.fields.benchmarkTitle.value),
              {
                benchmarkTitle: cleanName(l.fields.benchmarkTitle.value),
                benchmarkVersions: this.benchmarkVersions
                  .filter(
                    (c) =>
                      cleanName(c.fields.benchmarkTitle.value) ===
                        cleanName(l.fields.benchmarkTitle.value) && isEmpty(c.fields.images)
                  )
                  .map((i) => ({
                    version: cleanName(i.fields.benchmarkVersion.value)
                  }))
              }
            ])
        ).values()
      ].sort(sortVersion);

      return images;
    },
    getBuildKits() {
      const kits = [
        ...new Map(
          this.benchmarkVersions
            .filter((c) => isEmpty(c.fields.remediationKits))
            .map((l) => [
              cleanName(l.fields.benchmarkTitle.value),
              {
                benchmarkTitle: cleanName(l.fields.benchmarkTitle.value),
                benchmarkVersions: this.benchmarkVersions
                  .filter(
                    (c) =>
                      cleanName(c.fields.benchmarkTitle.value) ===
                        cleanName(l.fields.benchmarkTitle.value) &&
                      isEmpty(c.fields.remediationKits)
                  )
                  .map((i) => ({
                    version: cleanName(i.fields.benchmarkVersion.value)
                  }))
              }
            ])
        ).values()
      ].sort(sortVersion);

      return kits;
    },
    getImagesCount() {
      return this.routeData.fields.benchmarkVersions.filter(
        (item) => item.fields.images.length > 0
      );
    },
    getKitCount() {
      return this.routeData.fields.benchmarkVersions.filter(
        (item) => item.fields.remediationKits.length > 0
      );
    },
    getCommunityCount() {
      return this.routeData.fields.benchmarkVersions.filter(
        (item) => item.fields.community.length > 0
      );
    },
    sortByDate() {
      function compare(a, b) {
        if (a.fields.published.value > b.fields.published.value) return -1;
        if (a.fields.published.value < b.fields.published.value) return 1;
        return 0;
      }

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.routeData.fields.benchmarkVersions.slice().sort(compare);
    }
  },
  methods: {
    contentGrayBoxInfo() {
      return {
        icon: this.getBenchmarkData.grayBoxIcon,
        content: this.getBenchmarkData.grayBoxContent
      };
    },
    setRecentlyViewedBenchmarksCookie(data) {
      var technologyKey = data?.target?.getAttribute('tech_key');
      var technologyVersion = data?.target?.getAttribute('tech_version');
      var version = data?.target?.getAttribute('version');
      var href = data?.target?.getAttribute('href');

      var recentlyViewedBenchmarks = Cookies.getJSON('recentlyViewedBenchmarks') || [];

      var exists = false;

      for (var z = 0; z < recentlyViewedBenchmarks.length; z++) {
        var benchmark = recentlyViewedBenchmarks[z];

        if (
          benchmark.technologyKey === technologyKey &&
          benchmark.technologyVersion === technologyVersion &&
          benchmark.version === version
        ) {
          exists = true;
        }
      }

      if (!exists) {
        if (recentlyViewedBenchmarks.length >= 5) {
          recentlyViewedBenchmarks.splice(-1, 1);
        }
        recentlyViewedBenchmarks.unshift({
          technologyKey: technologyKey,
          technologyVersion: technologyVersion,
          version: version
        });

        if (Cookiebot?.consent?.preferences)
          Cookies.set('recentlyViewedBenchmarks', recentlyViewedBenchmarks, {
            domain: '.cisecurity.org'
          });

        window.location = href;
      }
    }
  },
  mounted() {
    if (window.innerWidth <= 991) {
      if (document.querySelector('.template-sidebar')) {
        var sideBar = document.querySelector('.template-sidebar').innerHTML;
        var newSideBar = sideBar.replace(new RegExp('<!---->', 'g'), '');

        if (newSideBar != '') {
          this.isContent = true;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.template-content {
  &:deep() {
    h1 {
      margin-bottom: 1rem;
    }

    h2 {
      font-size: 2.5rem;
      margin: 4rem 0 1rem 0;
    }

    .benchmark {
      h3 {
        &::before {
          display: none;
        }
      }
    }

    .c-cta--primary--benchmark {
      display: inline-block;
      position: relative;
      max-width: 39rem;
      background-color: $orange;
      padding: 1.6rem 6rem 1.6rem 2rem;
      text-transform: uppercase;
      border-radius: 0.4rem;
      justify-content: center;
      align-items: center;
      margin-top: 0.8rem;
      margin-bottom: 3.6rem;
      border: none;

      @include desktop-up {
        margin-bottom: 4.6rem;
      }

      &:after {
        content: '';
        position: absolute;
        top: 50%;
        right: 2rem;
        // background-image: url(~@/assets/images/icon-arrow-right-white-mobile.svg);
        // background-repeat: no-repeat;
        // background-size: contain;
        -webkit-mask: url(~@/assets/images/icon-arrow-right-white-mobile.svg);
        mask: url(~@/assets/images/icon-arrow-right-white-mobile.svg);
        background-color: $dark-blue;
        width: 1.7rem;
        min-width: 1.7rem;
        height: 1.3rem;
        min-height: 1.3rem;
        transition: 0.25s;
        transform: translateY(-50%);
      }

      &:hover,
      &:focus,
      &:active {
        color: $white;
        text-decoration: none;
        background-color: $dark-orange;
      }

      &:hover {
        &:after {
          right: 1rem;
        }
      }

      span {
        display: block;
        font-family: 'Arial Narrow';
        font-weight: 200;
        font-size: 1.4rem;
      }
    }
    .c-cta--primary--benchmark__desc {
      font-size: 1.4rem;
      line-height: 1.4rem;
      max-width: 39rem;
    }

    .c-cta--second--benchmark {
      position: relative;
      display: inline-block;
      padding: 1.1rem 4rem 1.1rem 1.4rem;
      text-transform: uppercase;
      justify-content: center;
      align-items: center;
      margin-bottom: 2.5rem;
      @include font-styles('Arial Narrow', 1.8rem, 600, normal, 2.2rem, 0, $blue);
      border-left: solid 0.4rem $blue;

      &:after {
        content: '';
        position: absolute;
        top: 50%;
        right: 1rem;
        background-image: url(~@/assets/images/icon-arrow-right-blue-sm.svg);
        background-repeat: no-repeat;
        background-size: contain;
        margin-left: 1rem;
        width: 1.9rem;
        min-width: 1.9rem;
        height: 1.5rem;
        min-height: 1.5rem;
        transition: 0.25s;
        left: auto;
      }

      &:hover {
        &:after {
          right: 0.5rem;
        }
      }

      span {
        display: block;
        font-family: 'Arial Narrow';
        font-weight: 200;
        font-size: 1.4rem;
        line-height: 1.6rem;
        margin-top: 0.5rem;
      }
    }

    .c-cta--tertiary--benchmark {
      position: relative;
      display: inline-block;
      padding: 0.5rem 3rem 0.5rem 0;
      text-transform: uppercase;
      justify-content: center;
      align-items: center;
      margin-bottom: 2.5rem;
      @include font-styles('Arial Narrow', 1.4rem, 600, normal, 2.2rem, 0, $blue);

      &:after {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-27%);
        right: 1rem;
        background-image: url(~@/assets/images/icon-arrow-right-blue-sm.svg);
        background-repeat: no-repeat;
        background-size: contain;
        margin-left: 1rem;
        width: 1.2rem;
        min-width: 1.2rem;
        height: 1.2rem;
        min-height: 1.2rem;
        transition: 0.25s;
        left: auto;
      }

      &:hover {
        &:after {
          right: 0.5rem;
        }
      }

      span {
        display: block;
        font-family: 'Arial Narrow';
        font-weight: 200;
        font-size: 1.4rem;
        line-height: 1.6rem;
        margin-top: 0.5rem;
      }
    }

    .benchmark-community {
      margin-top: 4rem;
    }

    .benchmark-other {
      .benchmark-other__items {
        font-size: 1.6rem;
        line-height: 2rem;
      }
    }

    .desc {
      font-family: 'Arial Narrow';
      font-weight: 200;
      font-size: 1.4rem;
      line-height: 1.4rem;
      margin-bottom: 2rem;
    }
  }

  .benchamrk__title {
    @include font-styles('Arial Narrow', 3.6rem, 200, normal, 4.2rem, 0, $dark-blue);
    margin-bottom: 1rem;

    @include desktop-up {
      font-size: 5rem;
      line-height: 6.5rem;
      margin-bottom: 1.5rem;
    }
  }

  .benchamrk__subtitle {
    @include font-styles('Arial', 2.4rem, 200, normal, 3rem, 0, $dark-gray);
    background: none;
    -webkit-text-fill-color: $dark-gray;
    margin-top: 0;
    margin-bottom: 1.6rem;

    @include desktop-up {
      font-size: 3.6rem;
      line-height: 4.2rem;
      margin-bottom: 2.4rem;
    }

    &:before {
      display: none;
    }
  }

  .box__title {
    @include font-styles('Arial', 2rem, 200, normal, 2.6rem, 0, $dark-blue);
    background: none;
    -webkit-text-fill-color: $dark-blue;
    margin-bottom: 2rem;

    @include desktop-up {
      font-size: 2.8rem;
      line-height: 3.5rem;
      margin-bottom: 3.2rem;
    }
  }

  .box {
    border-top: solid 0.5rem $orange;
    box-shadow: 0 17px 18px 0 rgba(0, 0, 0, 0.08), 0 3px 8px 0 rgba(0, 0, 0, 0.08);
    padding: 2rem;
    margin-bottom: 2rem;

    @include desktop-up {
      padding: 3rem 2.4rem;
    }

    .label {
      display: block;
      text-align: left;
      @include font-styles('Arial Narrow', 1.4rem, 600, normal, 1.7rem, 0, $dark-blue);
      padding: 0;
      white-space: inherit;

      margin-bottom: 1.6rem;
      text-transform: uppercase;

      @include desktop-up {
        margin-top: 0.8rem;
      }
    }

    .columns {
      @include desktop-up {
        display: flex;
        flex-direction: row;
      }

      .column {
        @include desktop-up {
          width: 50%;
        }

        &:first-child {
          @include desktop-up {
            margin-right: 1.6rem;
          }
        }

        &:last-child {
          @include desktop-up {
            margin-left: 1.6rem;
          }
        }

        &__header {
          color: $dark-blue;
          margin-bottom: 0.8rem;
        }

        &__subheader {
          @include font-styles('Arial Narrow', 1.6rem, 500, normal, 2.2rem, 0, $dark-blue);
          @include desktop-up {
            font-size: 2rem;
            line-height: 2.6rem;
          }

          &:before {
            display: none;
          }
        }

        ul {
          padding-top: 0.5rem;
          margin-left: 0.5rem !important;

          li {
            &:last-child {
              margin-bottom: 0 !important;
            }
          }
        }

        .c-cta--secondary {
          font-weight: 600;
        }

        .benchmark {
          display: block;
          position: relative;
          padding: 0.5rem 0 0.5rem 2rem;
          margin-left: 0.2rem;

          &:before {
            content: '';
            width: 0.8rem;
            height: 0.8rem;
            background: $orange;
            position: absolute;
            left: 0;
            border-radius: 50%;
            top: 50%;
            transform: translateY(-50%);
          }
        }

        .no-margin {
          margin: 0;
        }
      }
    }
  }

  .column__headline {
    font-size: 2.4rem;

    @include desktop-up {
      font-size: 3.6rem;
    }
  }

  .three-column {
    margin: 2rem 0;

    @include desktop-up {
      display: flex;
      flex-direction: row;
      margin: 2rem 0 4rem 0;
    }

    .column {
      margin-bottom: 4rem;

      @include desktop-up {
        width: calc(100% / 3);
        padding: 1rem;
        margin-bottom: 0;
      }

      &:first-child {
        @include desktop-up {
          padding-left: 0;
        }
      }

      &:last-child {
        @include desktop-up {
          padding-right: 0;
        }
      }

      &:deep() {
        h3 {
          font-size: 2rem;
          line-height: 2.6rem;

          @include desktop-up {
            font-size: 2.8rem;
            line-height: 3.5rem;
          }
        }

        a[class^='c-cta'] {
          @include desktop-down {
            padding-bottom: 0;
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .c-content-gray-box {
    margin-top: 5rem;
  }
}
</style>
